import * as dtos from "@/models/dtos";
export interface RouteProps {
  name: string;
  id: string;
}
export interface PermissionProps {
  id: number;
  name: string;
}
export class CreateApplicantPDFExportRequest {
  form: string;
  applicantId: number;
  positionId: number;
}

export class PositionTemplateRequest {
  folderId: number;
  key: string;
  name: string;
  description: string;
  createdAt: number;
  createdBy: UserResponse;
  availableInPositionTypes: {
    positionTypeId: number;
    positionTypeName: string;
    included: boolean;
    default: boolean;
  }[] = [];
  metadata: MetaData;
}

export class PeriodProperty {
  startDate: string;
  endDate: string;
  checked: boolean;

  /**
   *
   */
  constructor(startDate: string, endDate: string, checked: boolean) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.checked = checked;
  }
}

export class DynamicProperty {
  placeholder = "";
  key = "";
  type = "";
  label = "";
  required = false;
  isHtml = false;
  order = 0;
  data: any;
  validators: any[] = [];
}

export class LabelTemplate {
  containerId = 0;
  labelId = 0;
  subject = "";
  content = "";
  name = "";
}
export class DynamicPropertyGroup {
  placeholder = "";
  key = "";
  type = "";
  label = "";
  required = false;
  isHtml = false;
  order = 0;
  data: DynamicPropertyGroupItem = new DynamicPropertyGroupItem();
  validators: PropertyValidator[] = [];
}
export class PropertyValidator {
  name = "";
  data: any;
  /**
   *
   */
  constructor(name: string, data: any) {
    this.name = name;
    this.data = data;
  }
}
export class AllowedAgeInPeriodPropertyValidator {
  name = "allowedAgeInPeriod";
  data: AllowedAgeInPeriod;
  /**
   *
   */
  constructor(data: AllowedAgeInPeriod) {
    this.data = data;
  }
}
export class AllowedAgeInPeriod {
  startDate: string = "";
  endDate: string = "";
  minAge: number = 1;
  maxAge: number = 100;
}

export class TemplateResponse {
  Content = "";
  LabelId = 0;
}
export class DynamicPropertyGroupItem {
  keys: Array<string> = [];
  label = "";
}

export class MetaData {
  foreignKey = 0;
  properties: DynamicProperty[] = [];

  /**
   *
   */
}
export class PropertyItem {
  id: any;
  item: DynamicProperty;

  /**
   *
   */
  constructor(item: DynamicProperty, id: any) {
    this.item = item;
    this.id = id;
  }
}

export class LoginResponse {
  token = "";
  expiration = "";
  decoded: TokenClaims;
}
export class TokenClaims {
  given_name = "";
  family_name = "";
  sub = "";
  role = "";
}
export class LoginRequest {
  username = "";
  password = "";
}
export class PaginationCollection<T> {
  take: 0;
  page: 1;
  skip: 0;
  total: 0;
  items: T;
}
export class BlogPostResponse {
  id: string;
  created: "";
  title: string;
  body: string;
}
export class CreateBlogPostRequest {
  id?: string;
  title: string;
  body: string;
}
export class CreateBlogPostResponse {
  data: string;
}
export class ContainerTemplateResponse {
  containerId: 0;
  id: "";
  text: "";
  title: "";
}
export class PositionResponse {
  companyLogo: "";
  name = "";
  isArchived = false;
  linkId: string | null = null;
  text = "";
  description = "";
  created = "";
  containerName = "";
  containerId = 0;
  id = 0;
  positionTypeId = 0;
  positionTypeName = "";
  totalApplicants = 0;
  totalUnProcessed = 0;
  stop = 0;
  start = 0;
  responsibleId? = "";
  userPositions: UserPositionResponse[] = [];
  permissions: PermissionResponse[] = [];
  applicants: ApplicationUserResponse[] = [];
  metadata: MetaData = new MetaData();
  views = 0;

  /**
   *
   */
  constructor() {
    this.start = 0;
    this.stop = this.start;
  }
}
export class PositionResponsibleResponse {
  title? = "";
  phoneNumber? = "";
  firstname? = "";
  lastname? = "";
  email = "";
}
export class PublicPositionResponse {
  name = "";
  imageUrl = ""; // test to see if we can use this to save the position image url
  text = "";
  description = "";
  created = "";
  containerName = "";
  containerId = 0;
  id = 0;
  positionTypeName = "";
  stop = 0;
  start = 0;
  responsible?: PositionResponsibleResponse = new PositionResponsibleResponse();
  metadata: MetaData = new MetaData();

  /**
   *
   */
  constructor() {
    this.start = 0;
    this.stop = this.start;
  }
}
export class ApplicantLog {
  type = "";
  applicantId = 0;
  created = "";
  id = "";
  message: "";
  user: "";
}
export class AttachmentRequest {
  data = "";
  filename = "";
}

export class MetadataAttachment {
  data = "";
  filename = "";
  id = "";
  url = "";
}
export class PositionRequest {
  name = "";
  text = "";
  responsibleId? = "";
  description = "";
  containerName = "";
  id = 0;
  containerId = 0;
  positionTypeId = 0;
  positionTypeName = "";
  stop = 0;
  start = 0;
  metadata: MetaData = new MetaData();
}
export class UserPositionResponse {
  user: ApplicationUserResponse = new ApplicationUserResponse();
  permission: PermissionResponse = new PermissionResponse();
}
export class ApplicationUserResponse {
  email = "";
  userId = "";
  id = 0;
  firstname = "";
  phoneNumber = "";
  lastname = "";
  title = "";
  permissionId: 0;
  otherOffer: false;
  users: ApplicationUserResponse[] = [];
}

export class UserResponse {
  id = 0;
  userId = "";
  email = "";
  permissionId = 0;
  firstname = "";
  lastname = "";
  phoneNumber = "";
  title = "";
}
export class ApplicantExportRequest {
  containerId: number;
  positionId: number;
  labelId: number;
  filter: "";
}
export class FolderResponse {
  assets: ImageResponse[];
  containerId = 0;
  created = "";
  id = 0;
  metadata: MetaData = new MetaData();
  modified = "";
  name = "";
}

export class FolderRequest extends FolderResponse {}
export class FolderAssetRequest {
  id: number;
  containerId: number;
  folderId: number;
  data: string;
  contentType: string;
  name: string;
}
export class CreateContainerUserPermission {
  email = "";
  containerId = 0;
  permissionId = 0;
}
export class CreateContainerUserPermissionResponse {
  email = "";
  userId = "";
}
export class UpdateContainerUserPermission {
  email = "";
  containerId = 0;
  permissionIds: number[] = [];
}
export class DeleteContainerUserPermission {
  id = 0;
  containerId = 0;
}

export class ApplicantInfo {
  address = "";
  age = 0;
  city = "";
  dateOfBirth: Date | undefined;
  email = "";
  emailNotificationSent = false;
  firstname = "";
  gender = "";
  lastname = "";
  name = "";
  ssn = "";
  zipCode = "";
}

export class SendMessageRequest {
  containerId: 0;
  to = "";
  body = "";
}
export class SendMessageResponse {
  containerId: 0;
  to = "";
  body = "";
  from = "";
}

export class NotificationResponse {
  userId = "";
  email = "";
  connectionId = "";
  containerId = 0;
  firstname: "";
  lastname: "";
}
export class ContainerResponse {
  name = "";
  id = 0;
  theme: CustomTheme;
  labels: LabelResponse[] = [];
  positionTypes: PositionTypeResponse[] = [];
  permissions: PermissionResponse[] = [];
  metadata: MetaData = new MetaData();
  users: ApplicationUserResponse[] = [];
  folders: FolderResponse[] = [];
}

export class ApplicantNotes {
  created: number;
  note: string;
  userId: string;
}

export class ApplicantPositionResponse {
  pId = 0;
  nId = 0;
  id = 0;
  created = "";
  userId = "";
  otherOffer: false;
  positionId: number | undefined;
  ApplicantStatusId: number | undefined;
  user: ApplicationUserResponse | undefined;
  position: PositionResponse | undefined;
  info: ApplicantInfo | undefined;
  notes: ApplicantNotes[] = [];
  labels: LabelResponse[] = [];
  logs: ApplicantLog[] = [];
  metadata: MetaData = new MetaData();
}

export class positionResponse {
  id: number | undefined;
  name: string | undefined;
  text: string | undefined;
}
export class PermissionResponse {
  name = "";
  id = 0;
}
export class UpdateContainerMetadataRequest {
  id = 0;
  metadata: dtos.MetaData;
  theme: dtos.CustomTheme;
  /**
   *
   */
  constructor(id: number, metadata: dtos.MetaData, theme: dtos.CustomTheme) {
    this.id = id;
    this.metadata = metadata;
    this.theme = theme;
  }
}

export class PositionPermission {
  Email = "";
  Position: PositionResponse = new PositionResponse();
  PermissionId: number[] = [];
  HaveAccess = false;
  Value = false;

  /**
   *
   */
  constructor(
    position: PositionResponse,
    permissionIds: number[],
    haveAccess: boolean,
    value: boolean,
    email: string
  ) {
    this.Position = position;
    this.PermissionId = permissionIds;
    this.HaveAccess = haveAccess;
    this.Value = value;
    this.Email = email;
  }
}

export class PositionPermissionRequest {
  email = "";
  permissions: [
    {
      positionId: number;
      permissions: number[];
    }
  ];
}
export class LabelResponse {
  id = 0;
  color = "";
  htmlClass = "";
  isDefault = false;
  labelType: LabelType = new LabelType();
  labelTypeId = 0;
  name = "";
  texter = "s";
  text = "";
}

export class PositionTypeResponse {
  id: number;
  name: string;
  templateId: number | null;
}

export class LabelType {
  id = 0;
  name = "";
  containerId = 0;
}
export class CheckboxFilterProps {
  id = 0;
  data: CheckboxFilter[] = [];
}

export class CheckboxFilter {
  key = "";
  value = "";
}

export class EmailVariable {
  name = "";
  description = "";
}

export class ContainerApplicant {
  userId = "";
  containerId = 0;
}

// Filter
export class FilterCategoryData {
  key = "";
  name = "";
  active = false;
}

export class FilterCategory {
  id = "";
  name = "";
  displayName = "";
  data: FilterCategoryData[] = [];
}

export class PositionFilter {
  positionId = 0;
  defaultFilter: FilterCategory[] = [];
  currentFilter: FilterCategory[] = [];
}

export class DashboardFilter {
  defaultFilter: FilterCategory[] = [];
  currentFilter: FilterCategory[] = [];
}

export class SortApplicantsInPosition {
  positionId = 0;
  currentSort: Sort = new Sort();
}

// Sort
export class Sort {
  key = "";
  direction: "asc" | "desc" = "asc";
}

export class SortingItem {
  key = "";
  sortable = false;
  label = "";
  hiddenIfSmaller = "";
}

export class ImageResponse {
  contentType: "";
  created = "";
  data = "";
  folderId = 0;
  id = 0;
  metadata: MetaData = new MetaData();
  modified = "";
  name = "";
}

export class SendEmailToOneRecipientRequest {
  applicantId?: number;
  email = "";
  subject = "";
  body = "";
}

export class SendEmailRequest {
  positionId = 0;
  recipients: [
    {
      applicantId: number;
    }
  ];
  subject = "";
  body = "";
}

export class UserExportRequest {
  userEmail = "";
  containerId = 0;
}

export class SelectedItems {
  form_ssn = false;
  form_firstname = false;
  form_surname = false;
  form_address = false;
  form_zipcode = false;
  form_city = false;
  form_email = false;
  form_mobilePhone = false;
  form_additional = false;
  form_referer = false;
  form_agreement = false;
  form_file = false;
  driverlicenseform = false;
  requirementsform = false;
  summerpositionchoicesform = false;
  summerpositionperiodsform = false;
  summerperiodsform = false;
  form_linkedInUrl = false;
  template_standard = false;
}

// Skills
export class SkillQuestion {
  id: string;
  question: string;
  answer?: string;
}

export class EditableSkill {
  id = "";
  name = "";
  description = "";
  icon = "";
  questions: SkillQuestion[] = [];
  categoryId: "";
}
export class Skill {
  id = "";
  name = "";
  description = "";
  icon = "";
  questions: SkillQuestion[] = [];

  constructor(id?: string, name?: string, description?: string, icon?: string) {
    this.id = id || "";
    this.name = name || "";
    this.description = description || "";
    this.icon = icon || "";
  }
}
export class SkillCollection {
  id = "";
  name = "";
  description = "";
  icon = "";
  skills: Skill[] = [];

  constructor(id?: string, name?: string, description?: string, icon?: string) {
    this.id = id || "";
    this.name = name || "";
    this.description = description || "";
    this.icon = icon || "";
  }
}

export class SkillCategory {
  id = "";
  name = "";
  skills: Skill[] = [];
}

export class GetApplicantQuestionaireRequest {
  applicantId = 0;
  containerId = 0;
}

export class UpsertApplicantQuestionaireRequest {
  applicantId = 0;
  containerId = 0;
  skills: Skill[] = [];
}

export class UpsertSkillCollection {
  id? = "";
  containerId = 0;
  name = "";
  description = "";
  icon = "";
  skillIds: string[] = [];
}

export class DeleteSkillCollection {
  containerId = 0;
  id = "";
}
export class UpsertSkillRequest {
  containerId = 0;
  categoryId = "";
  skill = new Skill();
}

export class DeleteSkillRequest {
  containerId = 0;
  id = "";
}

export interface PositionInformationForm {
  formTitle: string;
  formBannerImage: string;
  positionType: string;
  responsible?: string;
  text: string;
  description: string;
  applicationStartDate: string;
  applicationDeadline: string;
  positionIsInternal: boolean;
}

export class CreateDemoContainerRequest {
  name: string;
  applicants: number[];
}

export class ApplicantInformation {
  key: string;
  label: string;
  value: string | dtos.DynamicProperty[];
  type: "text" | "link" | "image" | "file" | "checkbox" | "date" | "number" =
    "text";
  visible?: boolean;
}

export class ApplicantRequirement {
  key: string;
  title: string;
  fullfilled: boolean;
}

interface LinkTo {
  name: string;
  params?: Record<string, string | number>;
}

export interface Breadcrumb {
  name: string;
  link?: string;
  disabled?: boolean;
  linkTo?: LinkTo;
}

export interface ActionItem {
  name: string;
  description: string;
  actionType: "modal" | "redirect" | "newTab" | "instant";
  action: () => void;
  icon: string;
  iconColor: string;
  permission?: "write" | "read" | "admin" | "odin";
  key?: string;
  disabled?: () => boolean | boolean;
  visible?: () => boolean | boolean;
  title?: string;
}

export interface SimplifiedApplicant {
  positionId: number;
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  age: number;
  otherOffer: boolean;
  gender: string | undefined;
  email: string | undefined;
  phone: string | undefined;
  city: string | undefined;
  hasNotes: boolean;
  hasReceivedEmail: boolean;
  status: dtos.LabelResponse | undefined;
  process: dtos.LabelResponse | undefined;
  hasManualDriverLicense: boolean;
  hasAutomaticDriverLicense: boolean;
  hasDriverLicense: boolean;
  hasOwnCar: boolean;
  requirements: { name: string; value: boolean; key: string }[] | undefined;
  checkboxGroup: { name: string; value: boolean; key: string }[] | undefined;
  radioGroups: { name: string; value: boolean; key: string }[] | undefined;
  positions: { name: string; value: boolean; key: string }[] | undefined;
  periods: { name: string; value: boolean; key: string }[] | undefined;
}

export class RadioItem {
  label: string;
  value: boolean;
  item: DynamicProperty;

  constructor(item: DynamicProperty, label?: string, value?: boolean) {
    this.label = label || "";
    this.value = value || false;
    this.item = item;
  }
}

export class BlogPost {
  id?: string;
  title: string;
  created: string;
  body: string;
}
export class EmailTemplate {
  id?: number;
  subject: string;
  body: string;
  containerId: number;
  positionTypeId: number;
  labelId?: number;
}

export class TextTemplate {
  id: number;
  title: string;
  text: string;
  containerId: number;
}

export class ErrorMessage {
  message: string;
  key: string;
  data: string;
  name: string;
}

export class CustomTheme {
  button: {
    backgroundColor: string;
    textColor: string;
    borderRadius:
      | "rounded-none"
      | "rounded-sm"
      | "rounded"
      | "rounded-md"
      | "rounded-lg"
      | "rounded-xl";
  };
  backgroundColor: {
    mainContent: string;
    footer: string;
    socialMedia: string;
  };
  textColor: {
    workAtText: string;
    contactText: string;
    detailText: string;
    otherText: string;
    footerText: string;
  };
  icon: {
    footerIcon: string;
    positionIcons: string;
    positionIcon1: string;
    positionIcon2: string;
    positionIcon3: string;
    positionIcon4: string;
    socialMedia: string;
  };
  [key: string]: any;

  constructor(theme?: CustomTheme) {
    this.button = theme?.button || {
      backgroundColor: "bg-blue-1",
      textColor: "text-white",
      borderRadius: "rounded-md",
    };
    this.backgroundColor = theme?.backgroundColor || {
      mainContent: "bg-white",
      footer: "bg-darkGray-1",
      socialMedia: "bg-blue-4",
    };
    this.textColor = theme?.textColor || {
      workAtText: "text-black",
      contactText: "text-blue-2",
      detailText: "text-darkGray-3",
      otherText: "text-gray-900",
      footerText: "text-gray-2",
    };
    this.icon = theme?.icon || {
      footerIcon: "text-white",
      positionIcons: "text-azure-1",
      positionIcon1: "text-blue-2",
      positionIcon2: "text-pink-1",
      positionIcon3: "text-sea-1",
      positionIcon4: "text-purple-1",
      socialMedia: "bg-blue-4",
    };
  }
}
